var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.812 8.437H15V6h-2.188c-.812 0-1.59.3-2.164.834a2.748 2.748 0 00-.898 2.01v1.218H8V12.5h1.75V19h2.625v-6.5h2.187L15 10.061h-2.625V8.844a.397.397 0 01.13-.286.46.46 0 01.307-.12z","fill":"#000"}));
}

FacebookInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
